import React from 'react';
import { supabase } from '../../lib/supabase';

interface UploadDocumentProps {
  caseId: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function UploadDocument({ caseId, onSuccess, onCancel }: UploadDocumentProps) {
  const handleUpload = async () => {
    try {
      // This would typically open a modal or form to upload a document
      // For now, we'll just trigger the UploadDocumentModal from the parent component
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error uploading document:', error);
    }
  };

  return (
    <button 
      onClick={handleUpload}
      className="flex items-center gap-1 text-blue-600 hover:text-blue-800 px-2 py-1 rounded-md hover:bg-blue-50"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
      </svg>
      <span>Upload</span>
    </button>
  );
}
